import React from "react";
import { motion } from "framer-motion";
import { skills } from "../../data/portfolio";

const colorMap = {
  primary: {
    border: "hover:border-[color:var(--primary)]",
    text: "hover:text-[color:var(--primary)]",
    dot: "text-[color:var(--primary)]",
    tag: "text-[color:var(--primary)]",
  },
  accent: {
    border: "hover:border-[color:var(--accent)]",
    text: "hover:text-[color:var(--accent)]",
    dot: "text-[color:var(--accent)]",
    tag: "text-[color:var(--accent)]",
  },
  secondary: {
    border: "hover:border-[color:var(--secondary)]",
    text: "hover:text-[color:var(--secondary)]",
    dot: "text-[color:var(--secondary)]",
    tag: "text-[color:var(--secondary)]",
  },
};

export const Skills = () => {
  return (
    <section id="skills" data-testid="skills-section" className="relative py-24 md:py-32 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-14">
          <div>
            <div className="text-xs font-mono-display uppercase tracking-widest text-[color:var(--primary)] mb-3">
              /02 · Stack
            </div>
            <h2 className="font-mono-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-semibold">
              The <span className="text-gradient-neon">toolkit</span> I ship with.
            </h2>
          </div>
          <p className="text-white/60 max-w-md font-body text-sm md:text-base">
            Curated for production — every chip below has shipped in a paying customer environment.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {skills.map((group, i) => {
            const c = colorMap[group.color] || colorMap.primary;
            return (
              <motion.div
                key={group.group}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.5, delay: i * 0.06 }}
                data-testid={`skill-group-${group.group.toLowerCase().replace(/[^a-z]/g,'-')}`}
                className="glass rounded-2xl p-6 hover:border-white/20 transition-all"
              >
                <div className="flex items-center gap-2 mb-4">
                  <span className={`${c.dot} text-lg leading-none`}>●</span>
                  <h3 className={`font-mono-display text-base tracking-tight ${c.tag}`}>{group.group}</h3>
                </div>

                <div className="flex flex-wrap gap-2">
                  {group.items.map((item) => (
                    <span
                      key={item}
                      className={`text-xs md:text-sm font-body px-3 py-1.5 rounded-full border border-white/10 text-white/75 transition-all ${c.border} ${c.text} hover:bg-white/5`}
                    >
                      {item}
                    </span>
                  ))}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Skills;